import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLang } from "@/context/LanguageContext";
import { media } from "@/data/content";
import { Reveal } from "@/components/Reveal";

export const About = () => {
  const { t } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y1 = useTransform(scrollYProgress, [0, 1], ["-6%", "8%"]);
  const y2 = useTransform(scrollYProgress, [0, 1], ["8%", "-6%"]);

  return (
    <section id="about" data-testid="about" className="relative bg-[#FAFAF7] py-24 md:py-36">
      <div ref={ref} className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <Reveal>
              <p className="text-sm tracking-luxe uppercase text-[#A39B8E] mb-6">{t.about.kicker}</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-[#1A1A1A]">
                {t.about.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 font-display italic text-2xl md:text-3xl text-[#8B7355]">
                “{t.about.motto}”
              </p>
            </Reveal>
            <div className="mt-8 space-y-5 max-w-lg">
              {t.about.body.map((p, i) => (
                <Reveal key={i} delay={0.15 + i * 0.08}>
                  <p className="text-[#1A1A1A]/70 leading-relaxed">{p}</p>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 md:gap-6">
            <motion.div style={{ y: y1 }} className="overflow-hidden aspect-[3/4] mt-8">
              <img src={media.aboutMain} alt="Store Zen Home" className="w-full h-full object-cover" />
            </motion.div>
            <motion.div style={{ y: y2 }} className="overflow-hidden aspect-[3/4]">
              <img src={media.aboutSecondary} alt="Tessili naturali" className="w-full h-full object-cover" />
            </motion.div>
          </div>
        </div>

        <div className="mt-20 md:mt-28 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10">
          {t.about.values.map((v, i) => (
            <Reveal
              key={i}
              delay={i * 0.08}
              className="bg-[#FAFAF7] p-8 md:p-10 hover:bg-[#F3EFEA] transition-colors duration-500"
            >
              <span className="font-display text-3xl text-[#8B7355]">0{i + 1}</span>
              <h3 className="mt-4 text-lg font-medium">{v.title}</h3>
              <p className="mt-2 text-sm text-[#1A1A1A]/60 leading-relaxed">{v.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
